import React, { useState } from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { Header } from "../../ApplicationStatus/Header";
import { Overview } from "../../ApplicationStatus/Overview";
import { Chat } from "../../ApplicationStatus/Chat";
import { Email } from "../../ApplicationStatus/Email";
import { Logs } from "../../ApplicationStatus/Logs";
import { Timeline } from "../../ApplicationStatus/Timeline";
import { Document } from "../../ApplicationStatus/Document";

export const ApplicantDetails = ({ show, gid, projectId, toggle }) => {
  const [activeKey, setActiveKey] = useState("Overview");

  const handleChangeTab = (key) => {
    setActiveKey(key);
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      fullscreen
      backdrop="static"
      className="text-start right modal-slider modal-max-w-overview overview-modal"
    >
      <Modal.Header closeButton className="text-white bg-primary-800">
        <div className="applicant-status-bar rounded-2 w-100">
          <Header gid={gid} hideBackButton={true} />
        </div>
      </Modal.Header>
      <Modal.Body className="bg-grey-50">
        <div className="slide-status-nav position-relative position-sticky top-0 z-1">
          <Tabs
            activeKey={activeKey}
            onSelect={handleChangeTab}
            id="applicant-details-tab"
            className="px-5 column-gap-1 flex-nowrap nowrap-tab position-sticky top-0 z-11 bg-white"
            mountOnEnter={false}
            unmountOnExit={false}
          >
            <Tab eventKey="Overview" title="Applicant Overview" className="text-nowrap">
              {activeKey === "Overview" && (
                <Overview gid={gid} projectId={projectId} />
              )}
            </Tab>
            <Tab eventKey="Chat" title="Comment">
              {activeKey === "Chat" && <Chat gid={gid} />}
            </Tab>
            <Tab eventKey="Email" title="Email">
              {activeKey === "Email" && <Email gid={gid} />}
            </Tab>
            <Tab eventKey="Logs" title="Logs">
              {activeKey === "Logs" && <Logs gid={gid} />}
            </Tab>
            <Tab eventKey="Timeline" title="Timeline">
              {activeKey === "Timeline" && <Timeline gid={gid} />}
            </Tab>
            <Tab eventKey="Document" title="Document">
              {activeKey === "Document" && <Document gid={gid} />}
            </Tab>
          </Tabs>
        </div>
      </Modal.Body>
    </Modal>
  );
};
